import 'jquery/dist/jquery.min.js';
import * as bootstrap from 'bootstrap';
import * as bootbox from "bootbox";
import { renderToStaticMarkup } from "react-dom/server"

export class ModalService {
    constructor() {
        window.config.bootstrap = bootstrap;
        window.bootbox = bootbox;
        bootbox.setDefaults({
            className: 'mrg-modal'
        });
    }
    displayModal() {
        bootbox.setDefaults({
            className: 'mrg-modal'
        });
        bootbox.alert('hey!');
    }
    displayAlert(message) {
        bootbox.alert(message);
    }
    displayDialog(config) {
        const defaultButtons = {
            close: {
                label: 'Close',
                className: 'btn-primary'
            }
        }
        bootbox.dialog({
            title: config.title,
            message: renderToStaticMarkup(config.message),
            buttons: { ...defaultButtons, ...config.buttons},
            size: config.size ? config.size : 'xl',
            closeButton: false 
        })
    }
}